var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "not-found-container" },
    [
      _c(_setup.HeaderComponent),
      _c("section", { staticClass: "info-section" }, [
        _c("img", {
          staticClass: "vector",
          attrs: {
            src: require("@/assets/images/svg/not-found.svg"),
            alt: "Not found",
          },
        }),
        _c("div", { staticClass: "row-1" }, [
          _c("span", { staticClass: "oops" }, [
            _vm._v(_vm._s(_setup.text.oops)),
          ]),
          _c("span", { staticClass: "something-wrong" }, [
            _vm._v(_vm._s(_setup.text.somethingWrong)),
          ]),
        ]),
        _c("div", { staticClass: "row-2" }, [
          _c("span", [_vm._v(_vm._s(_setup.text.errorText))]),
        ]),
        _c(
          "div",
          { staticClass: "row-3" },
          [
            _c(_setup.LfLabelButtonComponent, {
              attrs: {
                text: _setup.text.goToDashboard,
                action: () => _setup.gotodashboard(),
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "row-4" }, [
          _c("span", { staticClass: "help-text" }, [
            _vm._v(_vm._s(_setup.text.needHelp)),
          ]),
          _c("div", { staticClass: "info-container" }, [
            _c("div", { staticClass: "phone-container" }, [
              _c("span", { class: [_setup.icon.phone, "icon"] }),
              _c("span", { staticClass: "info-text" }, [
                _vm._v(_vm._s(_setup.text.phones)),
              ]),
            ]),
            _c("div", { staticClass: "email-container" }, [
              _c("span", { class: [_setup.icon.email, "icon"] }),
              _c(
                "a",
                {
                  staticClass: "info-text",
                  attrs: { href: "mailto:clientes@lefebvre.es" },
                },
                [_vm._v(_vm._s(_setup.text.email))]
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }